<template>
  <div class="authCompany">
    <el-dialog
      :visible.sync="visible"
      title="账号绑定企业"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <h4 v-if="tip">{{ tip }}</h4>
        <el-form
          ref="dataForm"
          :model="dataForm"
          :rules="dataRule"
          label-width="120px"
          @keyup.enter.native="onConfirm()"
        >
          <el-form-item label="企业名称" prop="companyName">
            <el-select
              class="w-full"
              v-model="dataForm.companyName"
              filterable
              remote
              reserve-keyword
              placeholder="请输入企业名称"
              @change="onCompanyChange"
              :remote-method="companyRemoteMethod"
              :loading="companyLoading"
            >
              <el-option
                v-for="i in companyOptions"
                :key="i.value"
                :label="i.label"
                :value="i.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="社会信用代码" prop="socialCreditCode">
            <el-input v-model="dataForm.socialCreditCode"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="footer">
          <el-button plain @click="onClose"> 取消 </el-button>
          <el-button type="primary" @click="onConfirm"> 提交 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { USCCReg } from "@/utils/reg";

export default {
  data() {
    return {
      visible: false,
      dataForm: {
        socialCreditCode: "",
        companyName: "",
      },
      dataRule: {
        socialCreditCode: [
          {
            required: true,
            pattern: USCCReg,
            message: "请输入正确的社会信用代码",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请填写企业名称",
            trigger: "blur",
          },
        ],
      },
      companyInfo: null,
      tip: "",
      companyOptions: [],
      companyLoading: false,
    };
  },
  methods: {
    onShow(tip) {
      this.tip = tip;
      this.dataForm = {
        socialCreditCode: "",
        companyName: "",
      };
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    onConfirm() {
      console.log("onConfirm");
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$http
          .get(
            `/front/cross/cust-company/check?socialCreditCode=${this.dataForm.socialCreditCode}&companyName=${this.dataForm.companyName}`
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data) {
                this.companyInfo = res.data;
                this.addCompanyHandle();
              } else {
                this.$http
                  .post(`/front/user/sys/custUser/saveCompany`, {
                    ...this.dataForm,
                    mobile: this.$store.state.user.mobile,
                    name: this.$store.state.user.name,
                  })
                  .then(({ data: res }) => {
                    if (res.code === 0) {
                      this.$message.success("企业认证提交成功");
                      this.onClose();
                      this.$emit("comfirm");
                    }
                  });
              }
            }
          });
      });
    },
    addCompanyHandle() {
      this.$confirm(
        "存在已注册的同名企业，如果您是该企业的成员，请申请加入企业，或者更换企业名称后再试。",
        "企业加入申请",
        {
          confirmButtonText: "申请加入",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const parmas = {
            userId: this.$store.state.user.userId,
            companyId: this.companyInfo.companyId,
            registClient: "PC",
          };
          this.$http
            .post(`/front/consumer/usercenter/apply-to-join`, parmas)
            .then(({ data: res }) => {
              if (res.code === 0) {
                this.$message.success("申请加入提交成功");
                this.onClose();
                this.$emit("comfirm");
              }
            });
        })
        .catch(() => {});
    },
    onCompanyChange(res) {
      const val = (this.companyOptions || []).find(
        (i) => i.companyName === res
      );
      this.dataForm.socialCreditCode = val.socialCreditCode;
    },
    companyRemoteMethod(str) {
      if (!str) return;
      this.companyLoading = true;
      this.$http
        .get(
          `/inter/qixinbao/fuzzyQueryByKeyword?keyword=${str}&matchType=ename&region=&skip=`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.companyOptions = res.data.map((item) => {
              return {
                ...item,
                label: item.companyName,
                value: item.companyName,
              };
            });
          }
        })
        .finally(() => {
          this.companyLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  padding: 8px 24px;
}

.footer {
  display: flex;
  justify-content: flex-end;
}
.authCompany {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}

.w-full {
  width: 100%;
}
</style>
